import { isEmpty } from "lodash";

const RenderOdds = ({
  component,
  handelChange,
  odds_lay,
  odds_back,
  item,
  limit,
  disabelBack,
  disabelLay,
  conditionNew,
  oldBack,
  oldLay,
  disableFull,
  ms,
  active,
  betType,
  index,
}) => {
  let checkDisabled = (odds) => {
    if (Number(odds) > 0) {
      if (Number(odds) > limit?.oddsLimit) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };
  let check = (odds) => {
    if (!conditionNew) {
      if (Number(odds) > 0 || !isEmpty(odds)) {
        if (Number(odds) > limit?.oddsLimit) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      return false;
    }
  };

  return (
    <div className="s-w-129px s-relative s-grid s-gap-1px s-grid-cols-2 s-self-start dark:s-text-black-900">
      {odds_back?.length > 0 ? (
        odds_back?.slice(0, 1)?.map((res, id) => {
          let chamak =
            oldBack?.length > 0
              ? res?.rt != oldBack[id]?.rt || res?.bv != oldBack[id]?.bv
              : false;
          return (
            <div
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (disabelBack) {
                } else {
                  if (!checkDisabled(res?.rt)) {
                    handelChange(res, "back", item?.RunnerName, item, e);
                  }
                }
              }}
              style={check(res?.rt) ? { cursor: "not-allowed" } : {}}
              data-v-b828fe26
              className={`${
                active && betType == "back" ? "back-active" : ""
              } s-w-64px s-flex s-flex-col s-justify-center s-items-center s-text-center s-rounded-3px s-min-h-48px s-relative s-overflow-hidden s-bg-back-300 dark:s-bg-back-400-dark ${
                chamak ? "s-animate-spark-back" : ""
              }`}
              title="BACK"
            >
              {check(res?.rt) && ms == 1 && !disableFull && (
                <div className="s-absolute s-right-0 s-top-0 s-flex s-justify-center s-items-center s-w-129px s-h-full s-bg-black-600 dark:s-bg-black-800 s-opacity-80 s-text-11px s-text-white s-rounded-3px s-z-20" />
              )}
              <p data-v-b828fe26 className="s-text-17px s-font-bold s-pb-0.5">
                {res?.rt || ""}
              </p>
              {component !== "bookmaker" && res?.bv > 0 && (
                <p data-v-b828fe26 className="s-text-11px">
                  {res?.bv || ""}
                </p>
              )}
            </div>
          );
        })
      ) : (
        <div
          data-v-b828fe26
          className="s-w-64px s-flex s-flex-col s-justify-center s-items-center s-text-center s-rounded-3px s-min-h-48px s-relative s-overflow-hidden s-bg-back-300 dark:s-bg-back-400-dark"
          title="BACK"
        >
          <p data-v-b828fe26 className="s-text-17px s-font-bold s-pb-0.5"></p>
          <p data-v-b828fe26 className="s-text-11px"></p>
        </div>
      )}
      {odds_lay?.length > 0 ? (
        odds_lay?.slice(0, 1)?.map((res, id) => {
          let chamak =
            oldLay?.length > 0
              ? res?.rt != oldLay[id]?.rt || res?.bv != oldLay[id]?.bv
              : false;
          return (
            <div
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (disabelLay) {
                } else {
                  if (!checkDisabled(res?.rt)) {
                    handelChange(res, "lay", item?.RunnerName, item, e);
                  }
                }
              }}
              style={check(res?.rt) ? { cursor: "not-allowed" } : {}}
              data-v-b828fe26
              className={`${
                active && betType == "lay" ? "lay-active" : ""
              } s-w-64px s-flex s-flex-col s-justify-center s-items-center s-text-center s-rounded-3px s-min-h-48px s-relative s-overflow-hidden s-bg-lay-300 dark:s-bg-lay-400-dark ${
                chamak ? "s-animate-spark-lay" : ""
              }`}
              title="LAY"
            >
              {((check(res?.rt) && ms == 1 && !disableFull) || disabelLay) && (
                <div className="s-absolute s-right-0 s-top-0 s-flex s-justify-center s-items-center s-w-129px s-h-full s-bg-black-600 dark:s-bg-black-800 s-opacity-80 s-text-11px s-text-white s-rounded-3px s-z-20" />
              )}
              <p data-v-b828fe26 className="s-text-17px s-font-bold s-pb-0.5">
                {res?.rt || ""}
              </p>
              {component !== "bookmaker" && res?.bv > 0 && (
                <p data-v-b828fe26 className="s-text-11px">
                  {res?.bv || ""}
                </p>
              )}
            </div>
          );
        })
      ) : (
        <div
          data-v-b828fe26
          className="s-w-64px s-flex s-flex-col s-justify-center s-items-center s-text-center s-rounded-3px s-min-h-48px s-relative s-overflow-hidden s-bg-lay-300 dark:s-bg-lay-400-dark"
          title="LAY"
        >
          <p data-v-b828fe26 className="s-text-17px s-font-bold s-pb-0.5"></p>
        </div>
      )}
      {disableFull && ms == 1 && (
        <div class="s-absolute s-right-0 s-top-0 s-flex s-justify-center s-items-center s-w-full s-h-full s-bg-black-600 dark:s-bg-black-800 s-opacity-80 s-text-15px s-text-white s-rounded-3px s-z-20">
          Suspended
        </div>
      )}
    </div>
  );
};

export default RenderOdds;
